<template>
  <v-card>
    <v-card-text>
      <v-layout row wrap>
        <v-flex xs4 sm4 md4 lg4>
          <img style="width: 100%;max-height:290px;object-fit:contain;" alt="Profile Image" :src="currentImage" />
        </v-flex>
        <v-flex xs8 sm8 md8 lg8>
          <v-card>
            <v-form @submit.prevent="update" ref="form" class="pl-3 pr-3">
              <v-layout row wrap>
                <v-flex xs12 sm12 lg6>
                  <v-text-field :loading="loading" v-model="player.registerNumber" label="Register Number" @keyup.enter.prevent="update" :rules="[validate()]" :error-messages="loadErrors"></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 lg6>
                  <v-text-field :loading="loading" v-model="player.jerseyNo" label="Jersey No" :rules="[validateJersey]" :error-messages="jerseyError"></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
            <v-list :class="{ 'banned-player': player.isBlocked }">
              <v-list-tile ripple key="Name">
                <v-list-tile-content>
                  <v-list-tile-title>
                    <v-layout row wrap>
                      <v-flex xs3 sm2>
                        <span class="blue-grey--text text--lighten-3">Name:</span>
                      </v-flex>
                      <v-flex xs6 sm7>
                        <span>{{ player.name }}</span>
                      </v-flex>
                      <v-flex xs3 sm3>
                        <span v-if="player.hockeyIndiaRegNo" title="Hockey India RegNo">({{ player.hockeyIndiaRegNo }})</span>
                      </v-flex>
                    </v-layout>
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider></v-divider>

              <v-list-tile ripple key="DOB">
                <v-list-tile-content>
                  <v-list-tile-title>
                    <v-layout row wrap>
                      <v-flex xs3 sm2>
                        <span class="blue-grey--text text--lighten-3">DOB:</span>
                      </v-flex>
                      <v-flex xs9 sm10>
                        <span>{{ player.dateOfBirth | formatDate }}</span>
                      </v-flex>
                    </v-layout>
                  </v-list-tile-title>
                  <v-list-tile-sub-title class="text--primary"></v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider></v-divider>

              <v-list-tile ripple key="Guardian">
                <v-list-tile-content>
                  <v-list-tile-title>
                    <v-layout row wrap>
                      <v-flex xs3 sm2>
                        <span class="blue-grey--text text--lighten-3">Guardian:</span>
                      </v-flex>
                      <v-flex xs9 sm10>
                        <span>{{ player.guardian }}</span>
                      </v-flex>
                    </v-layout>
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider></v-divider>

              <v-list-tile ripple key="Address">
                <v-list-tile-content>
                  <v-list-tile-title>
                    <span class="blue-grey--text text--lighten-3">Address:</span>
                    <span>{{ player.address.line1 }}</span>
                  </v-list-tile-title>
                  <v-list-tile-sub-title class="text--primary">
                    <span v-for="addr in formattedAddress" v-bind:key="addr">{{ addr }}, </span>
                    <span>{{ player.district }}</span>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
export default {
  props: ["regNo", "filterCategory", "jerseyNo","showJerseyValidation"],
  data: function() {
    return {
      player: {
        id: "",
        registerNumber: "",
        name: "",
        dateOfBirth: "",
        guardian: "",
        address: "",
        profileImage: "",
        isBlocked: false,
        isBarred: false,
        jerseyNo: "",
      },
      defaultImage: "",
      loading: false,
      error: "",
    };
  },
  mounted: function() {
    if (this.regNo) this.load(this.regNo);
    else this.reset();
  },
  filters: {
    formatDate: function(date) {
      return !date ? "" : moment(date).format("DD-MMM-YYYY");
    },
    formatGender: function(i) {
      return ["Female", "Male"][i];
    },
  },
  methods: {
    validate: function() {
      return this.error ? this.error : true;
    },
    update: function() {
      if (!this.player.registerNumber) {
        this.reset();
        this.$emit("update:regNo", null);
      } else this.load(this.player.registerNumber);
    },
    validateJersey: function() {
      return this.player.registerNumber && !this.player.jerseyNo ?  "Enter Jersey No" : true;
    },
    load: function(v) {
      if (!v) return;

      var me = this;
      me.loading = true;
      this.$api("players")
        .get({ id: v })
        .then(function(resp) {
          Object.assign(me.player, resp);
        })
        .catch(function() {
          me.error = "Not Found!";
        })
        .finally(function() {
          me.loading = false;
        });
    },
    reset: function() {
      this.player = {
        id: "",
        registerNumber: "",
        name: "",
        dob: "",
        guardian: "",
        address: "",
        profileImage: this.defaults.profileImage,
        isBlocked: false,
        isBarred: false,
        jerseyNo: "",
      };

      this.error = "";
    },
  },
  computed: {
    ...mapState("config", ["defaults", "meta"]),
    currentImage: function() {
      if (!this.player || !this.player.id) return this.defaults.profileImage;

      return this.meta.baseUrl + "/serve/profileimage/" + this.player.id + ".jpg";
    },
    loadErrors: function() {
      return this.error ? [this.error] : [];
    },
    formattedAddress: function() {
      return this.player.address ? this.player.address.split("\n") : [];
    },
    jerseyError:function(){
      if(this.showJerseyValidation){
        if(this.player.registerNumber && !this.player.jerseyNo)
          return ["Provide jersey no"];
      }

      return [];
    }
  },
  watch: {
    regNo: function(nv) {
      if (!nv) this.reset();
      else if (this.player.registerNumber != nv) {
        this.load(nv);
      }
    },
    "player.registerNumber": function(nv) {
      this.error = "";
      this.$emit("update:regNo", nv);
    },
    error: function() {
      this.$refs.form.validate();
    },
    jerseyNo: {
      immediate:true,
      handler:function(nv) {
      this.player.jerseyNo = nv;
    }
    },
    "player.jerseyNo": function(nv) {
      this.$emit("update:jerseyNo", nv);
    },
  },
};
</script>
